export const SET_EMPLOYEE_LIST = 'SET_EMPLOYEE_LIST'
export const SET_STORE_CONNECTION_CLIENTS = 'SET_STORE_CONNECTION_CLIENTS'
